// extracted by mini-css-extract-plugin
export default {"line-through":"section-title_line-through__QmLS7"};